import {writable} from 'svelte/store';

export const storedInput = writable(JSON.parse(localStorage.getItem('input')));
export const storedSelections = writable(JSON.parse(localStorage.getItem('selections')));
export const storedResult = writable(JSON.parse(localStorage.getItem('result')));

storedInput.subscribe((value) => localStorage.input = JSON.stringify(value));
storedSelections.subscribe((value) => localStorage.selections = JSON.stringify(value));
storedResult.subscribe((value) => localStorage.result = JSON.stringify(value));